import { render, staticRenderFns } from "./ScoreChart.vue?vue&type=template&id=6686baa4&"
import script from "./ScoreChart.vue?vue&type=script&lang=js&"
export * from "./ScoreChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports